import ApiService from '@dogfy/services/apiService'
import apiEndpoints from '@dogfy/services/apiEndpoints'

import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'

const app = initializeApp({
  apiKey: import.meta.env.VUE_APP_FIREBASE_PUSH_API_KEY,
  authDomain: import.meta.env.VUE_APP_FIREBASE_PUSH_AUTH_DOMAIN,
  databaseURL: import.meta.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VUE_APP_FIREBASE_PUSH_PROJECT_ID,
  storageBucket: import.meta.env.VUE_APP_FIREBASE_PUSH_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VUE_APP_FIREBASE_PUSH_MESSAGING_SENDER_ID,
  appId: import.meta.env.VUE_APP_FIREBASE_PUSH_APP_ID,
})

let messaging
// Check if all required APIs exist in the browser.
isSupported()
  .then(value => {
    if (value) {
      messaging = getMessaging(app)
      // Handle incoming push messages.
      onMessage(messaging, (payload) => {
        // TODO: Decide what to do with push notifications sent with Iterable.
        // Customize notification here.
        // const { title, body } = payload.notification
        // const notificationOptions = {
        //   body,
        //   icon: '/images/dog-cookies.png',
        // }
      })
    }
  })
  .catch((err) => {
    console.error(' !! Firebase messaging is not supported.', err)
  })

async function requestPermission () {
  const isNotificationSupported = !!(window.Notification /* W3C Specification */ || window.webkitNotifications /* old WebKit Browsers */ || navigator.mozNotification /* Firefox for Android and Firefox OS */)
  if (!isNotificationSupported) return

  try {
    // Request permission to send push notifications.
    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return

    // Get the push token from Firebase Cloud Messaging.
    // Retrieve the push token using the VAPID key. https://datatracker.ietf.org/doc/rfc8292/
    const token = await getToken(messaging, { vapidKey: import.meta.env.VUE_APP_FIREBASE_PUSH_VAPID_KEY })
    if (!token) {
      console.error('  !! Could not retrieve token.')
      return
    }

    const { data } = await ApiService.post(apiEndpoints.self.notifications.push.register, { token })
    return data
  } catch (err) {
    console.error('  !! Could not request permission.', err)
  }
}

// Export the requestPermission function for use in other parts of the application.
export default {
  requestPermission,
}
